import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CartService } from '../../services/cart.service';
import { Product, ProductAttribute } from '../../interfaces/product';
import { WishlistService } from '../../services/wishlist.service';
import { CompareService } from '../../services/compare.service';
import { QuickviewService } from '../../services/quickview.service';
import { RootService } from '../../services/root.service';
import { CurrencyService } from '../../services/currency.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NavigationService } from 'src/app/services/navigation.service';
import { FormControl } from '@angular/forms';
import { HomeshoppingDataService } from 'src/app/services/homeshopping-data.service';
import Swal from 'sweetalert2';


@Component({
    selector: 'app-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductCardComponent implements OnInit, OnDestroy, OnChanges {
    private destroy$: Subject<void> = new Subject();
    quantity: FormControl = new FormControl(1);

    @Input() product: any;
    @Input() layout: 'grid-sm' | 'grid-nl' | 'grid-lg' | 'list' | 'horizontal' | null = null;

    addingToCart = false;
    addingToWishlist = false;
    addingToCompare = false;
    showingQuickview = false;
    featuredAttributes: ProductAttribute[] = [];
    addedToCartProducts: any[] = [];


    constructor(
        private cd: ChangeDetectorRef,
        public root: RootService,
        public cart: CartService,
        public wishlist: WishlistService,
        public compare: CompareService,
        public quickview: QuickviewService,
        public currency: CurrencyService,
        private navigate: NavigationService,
        public homeShoppingDataService: HomeshoppingDataService,


    ) { }

    ngOnInit(): void {
        this.currency.changes$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.cd.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnChanges(changes: SimpleChanges): void {
        console.log('changes, ', changes);
        
        if ('product' in changes) {
            this.featuredAttributes = !this.product ? [] : this.product?.attributes?.filter(x => x?.featured);
        }
    }


    gotoproductbyId(id: any) {
        this.navigate.gotoproductbyId(id)
    }

    addToCart(product: any): void {
        this.addToCartValidation(product)

    }
    addToCartValidation(product: any) {
        debugger
        let data = {
            productDetailId: product.id,
            quantity: this.quantity.value
        }
        this.homeShoppingDataService.UpdateCart(data).subscribe((res) => {
            if (res) {
                this.addedSweetAlert(product);
                this.cartCount(product);
            } else {
            }
        },
            (error) => {
                console.error('Error updating cart:', error);
            }
        );
    }

    cartCount(product: any) {

        if (this.addedToCartProducts.includes(product)) {
            return;
        }
        this.addedToCartProducts.push(product);
        this.cart.add(product, 1).subscribe({
            complete: () => {
                this.addedToCartProducts = this.addedToCartProducts.filter(eachProduct => eachProduct !== product);
            }
        });
    }

    addedSweetAlert(product: any) {
        debugger
        const title = product?.productName;
        const text = `Added To Your Cart successfully`;
        const imageUrl = product?.logo || 'images/default_product.png';
        const showCancelButton = true;
        const confirmButtonColor = '#7D32DE';
        const confirmButtonText = 'Continue Shopping';
        const cancelButtonText = 'Go To Cart';

        Swal.fire({
            html: `
                    <div style="align-items: center;">
                        <br>
                        <img src="${imageUrl}" style="height: 100px;" alt="Custom Image"/>
                        <br>
                        <br>
                        <h4>${title}</h4>
                        <span style="margin-left: 10px;">${text}</span>
                    </div>`,
            imageWidth: 150,
            imageHeight: 150,
            imageAlt: 'Custom Image',
            showCancelButton,
            confirmButtonColor,
            cancelButtonColor: '#7D32DE',
            confirmButtonText,
            cancelButtonText,
        }).then((result) => {
            if (result.isConfirmed) {
                this.navigate.shop();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                this.navigate.gotocart();
            }
        });
    }

    showQuickview(): void {
        debugger
        if (this.showingQuickview) {
            return;
        }

        this.showingQuickview = true;
        this.quickview.show(this.product).subscribe({
            complete: () => {
                this.showingQuickview = false;
                this.cd.markForCheck();
            }
        });
    }
}
